<template>
  <div ui-view="" class="app-body" id="view">
    <div class="box mt-20">
      <div class="box-header">
        <!-- 방문요청 신청자 정보 입력 -->
        <h3>IDC 입실 정보 확인</h3>
        <!-- 이름, 연락처, 이메일주소 등 방문 신청자 정보를 입력하세요. -->
        <p>인적 사항 및 출입 기간 정보를 확인합니다.</p>
      </div>
    </div>

    <table class="tbl">
      <!--<colgroup><col width="16.66%"><col width="16.66%"><col width="16.66%"><col width="16.66%"><col width="16.66%"><col width="16.66%"></colgroup>-->
      <colgroup>
        <col width="120px">
        <col width="auto">
      </colgroup>
      <thead>
        <tr>
          <th></th>
          <th>CheckList</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            출입기간
          </td>
          <td>{{getDate(data.fromDate)}}~{{getDate(data.toDate)}}</td>
        </tr>
        <tr>
          <td>
            이름
          </td>
          <td>{{data.visitorName}}</td>
        </tr>
        <tr>
          <td>
            회사명
          </td>
          <td>{{data.visitorCompany}}</td>
        </tr>
        <tr>
          <td>
            이메일
          </td>
          <td>{{data.visitorMail}}</td>
        </tr>
        <tr>
          <td>
            방문목적
          </td>
          <td>{{getVisitTypeStr(data.changedVisitTypeCode ? data.changedVisitTypeCode : data.visitTypeCode)}}</td>
        </tr>
      </tbody>
    </table>
    <div class="box mt-20">
      <div class="box-header">
        <!-- 방문요청 신청자 정보 입력 -->
        <h3>반입 자산 확인</h3>
        <!-- 이름, 연락처, 이메일주소 등 방문 신청자 정보를 입력하세요. -->
        <p>반입 요청한 자산 정보를 확인합니다.</p>
      </div>
    </div>
    <table class="tbl">
      <!--<colgroup><col width="16.66%"><col width="16.66%"><col width="16.66%"><col width="16.66%"><col width="16.66%"><col width="16.66%"></colgroup>-->
      <colgroup>
        <col width="120px">
        <col width="auto">
        <col width="auto">
        <col width="auto">
        <col width="auto">
      </colgroup>
      <thead>
        <tr>
          <th>항목</th>
          <th>제조사</th>
          <th>모델명</th>
          <th>시리얼번호</th>
          <th>비고</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data.assetList" :key="index">
          <td class="ellipsis">{{item.visitorAssetCode.assetStr}}</td>
          <td class="ellipsis">{{item.assetManufacturer}}</td>
          <td class="ellipsis">{{item.assetModel}}</td>
          <td class="ellipsis">{{item.assetSerial}}</td>
          <td class="ellipsis">{{item.assetMemo}}</td>

        </tr>
      </tbody>
    </table>
    <div class="btn-wrap mt-30 mb-30 justify-content-center">

      <button class="btn btn-lg line-2" @click="prev()" v-if="showPrev" :disabled="submitting"><i class="icon-arrow-line-left mr-5"></i>이전</button>
      <!-- 중복 클릭 방지: 입실요청이 여러 건 생성되면 공란 기록이 남아 이후 입실처리를 가로챔 -->
      <button class="btn btn-lg blue" @click="enter()" v-if="showNext" :disabled="submitting">
        <span v-if="submitting">처리 중...</span>
        <span v-else>확인<i class="icon-check  ml-5"></i></span>
      </button>
    </div>
  </div>

</template>

<script>
import AgreeItem from '@/views/app/main/AgreeItem.vue';
export default {
  components: {AgreeItem },
  props: ['item', 'items', 'data', 'tos', 'checkList', 'visitTypeCode'],
  data(){
    return {
      checkItems:[

      ],
      // 입실요청 전송 중 플래그. 중복 클릭 시 요청이 동시에 여러 건 나가면
      // VisitorEntranceInfo 에 공란 행이 여러 개 생성됨 (입/퇴실 시간 null)
      submitting: false
    }
  },
  computed: {
    getDate(){
      return (date) => {
        return moment(date).format('YYYY-MM-DD')
      }
    },
    showPrev() {
      return this.item.id <= 1 ? false : true;
    },
    showNext(){
      return this.item.id <= this.items.length
    },
    isCheckNext() {
      if(!this.checkItems)
        return false;
      return this.checkItems.filter((item)=>{return item.checked}).length != this.checkItems.length;
    },
  },
  mounted(){

    this.loadItems();
  },
  methods: {
    prev(){
      this.$emit('changeStep', {item: this.item, action: -1})
    },
    enter(){
      // 중복 클릭 차단. 응답이 늦을 때 여러 번 눌리면 서버에 입실요청이 중복 생성된다.
      if (this.submitting) return;
      this.submitting = true;

      var that = this;
      var tos = this.tos.filter((x)=>x.isChecked).map((x)=>{return {tosIndex: x.tosIndex, isAgree:x.isChecked ? 1: 0}})

      var o = {tosList:tos, uuid: this.data.uuid, visitTypeCode: this.data.changedVisitTypeCode ? this.data.changedVisitTypeCode : this.data.visitTypeCode}

      this.$http.post('/api/private/visitor/enter', o)
        .then((result) => {
          // 성공 시엔 화면을 벗어나므로 submitting 을 풀지 않는다 (이탈 직전 재클릭 방지)
          this.closeModal();
          // this.$toast.success("입실 확인되었습니다.");
          this.noti('신청완료', '입실 신청이 완료되었습니다.', 'success');
          this.$router.push('qrScan');
        }).catch((e) =>{
          // 기존에는 실패를 통째로 삼켜, 이미 요청된 티켓이어도 사용자에게 아무 표시가 없었다.
          this.submitting = false;
          this.noti('신청 실패', this.enterErrorMessage(e), 'danger');
        })

    },
    // 서버 메시지 추출. 공통 응답 인터셉터가 statusCode==500 을 자체 처리하면서
    // 원본 메시지를 잃는 경우가 있어, 가능한 형태를 모두 훑고 없으면 일반 안내를 쓴다.
    enterErrorMessage(e){
      var res = e && e.response;
      var msg = (res && res.data && res.data.message)
             || (e && e.serverMessage)
             || '';
      if (msg && msg.indexOf('is not defined') < 0) return msg;
      return '입실 신청에 실패했습니다. 이미 신청된 건은 아닌지 확인 후 다시 시도해 주세요.';
    },
    getQuery(){
      var query = Object.assign({},this.$route.query);
      var tosList = this.checkItems.filter((item)=>{return item.isChecked});
            query.tos = JSON.stringify(_.chain(tosList)
      .keyBy('tosIndex')
      .mapValues('isChecked')
      .value());
      return query;
    },
    loadItems(){
      var that = this;
      this.$http.get('/api/public/checkList/2')
        .then((result) => {

          result.data.forEach((item) => {
            item.isChecked = false;
          });

          that.checkItems = result.data;
        }).catch((e) =>{
      })
    },
    checkAllHandler(){
      this.checkItems.forEach((item)=>{
        item.isChecked = !item.isChecked ;
      })
    },
    agreeCheckHandler(data){
      var that = this;
      this.checkItems.forEach((item)=>{
        if(data.tosIndex == item.tosIndex) {
          item.isChecked = data.isChecked;
          return;
        }
      })
    },
    getVisitTypeStr(visitTypeCode){
      let filtered = this.$store.getters["dropdown/dataprovider"].visitType.filter(typeObj => typeObj.visitTypeCode == visitTypeCode);
      debugger;
      return filtered[0] ? filtered[0].visitTypeStr : '';
    }
  }
}
</script>

<style>

